module.exports = __webpack_public_path__ + "img/carve_step2.ca47a145.png";